module.exports = __webpack_public_path__ + "static/img/first.5a69ed2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/research/first.png
// module id = JH9t
// module chunks = 1